import React from 'react';
import { Link } from 'react-router-dom';

const NavBarButton = ({ icon: Icon, label, onClick, link }) => (
  <Link
    to={link}
    onClick={onClick}
    className="text-white text-lg font-bold hover:bg-gray-500 hover:bg-opacity-50 hover:text-white px-4 py-2 rounded-lg flex items-center transition duration-300 ease-in-out transform hover:scale-105 shadow-md"
  >
    <Icon className="mr-2 text-xl" />
    {label}
  </Link>
);

export default NavBarButton;
